var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.137,
    height: 4.621,
    viewBox: "0 0 8.137 4.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M.848-7H7.9a.493.493,0,0,1,.492.342.5.5,0,0,1-.109.588L4.758-2.543a.525.525,0,0,1-.383.164.525.525,0,0,1-.383-.164L.465-6.07a.5.5,0,0,1-.109-.588A.493.493,0,0,1,.848-7Z",
    transform: "translate(-0.307 7)",
    fill: "#8c8b97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.22f224c3f07d2cd8883c28e8e0a2e37a.svg";
export { ForwardRef as ReactComponent };